import {
  Clock3,
  Headphones,
  HeartPulse,
  MapPin,
  MessageCircle,
  Pill,
  ShieldCheck,
  Smartphone,
  Stethoscope,
  Truck,
  type LucideIcon,
} from 'lucide-react'

export const BENEFIT_ICONS = {
  'shield-check': ShieldCheck,
  truck: Truck,
  smartphone: Smartphone,
  'message-circle': MessageCircle,
  'heart-pulse': HeartPulse,
  pill: Pill,
  stethoscope: Stethoscope,
  clock: Clock3,
  'map-pin': MapPin,
  headphones: Headphones,
} satisfies Record<string, LucideIcon>

export type BenefitIconName = keyof typeof BENEFIT_ICONS

export const BENEFIT_ICON_OPTIONS: ReadonlyArray<{
  value: BenefitIconName
  label: string
}> = [
  { value: 'shield-check', label: 'Compra segura' },
  { value: 'truck', label: 'Entrega' },
  { value: 'smartphone', label: 'Dispositivo móvil' },
  { value: 'message-circle', label: 'Atención por mensaje' },
  { value: 'heart-pulse', label: 'Salud y bienestar' },
  { value: 'pill', label: 'Medicamentos' },
  { value: 'stethoscope', label: 'Atención médica' },
  { value: 'clock', label: 'Horario' },
  { value: 'map-pin', label: 'Ubicación' },
  { value: 'headphones', label: 'Soporte' },
]
